import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { generateTkv2AdjustmentsRptiNodes } from '../generateTkv2AdjustmentsRptiNodes.js';
import { generateTkv2UADAnnotationRptiNodes } from '../generateTkv2UADAnnotationRptiNodes.js';

export function create1004cAdditionalCompsFormNode(
  doc: XMLDocument,
  compSequence: string[],
  comps: ReportJSON['comps'],
  meta?: ReportJSON['meta'],
): HTMLElement {
  const fnma1004AdditionalComps = doc.createElement('Form');
  fnma1004AdditionalComps.setAttribute('Id', 'FNMA-1004C-0305-SalesComps');

  const reportFields = doc.createElement('Fields');
  fnma1004AdditionalComps.append(reportFields);

  compSequence.forEach((compId, index) => {
    const comp = comps[compId];
    comp &&
      reportFields.append(
        ...generateTkv2UADAnnotationRptiNodes(doc, {
          property: comp,
          isComp: true,
          meta,
          compIndex: index,
        }),
      );
  });

  // Add Adjustments each comp
  compSequence.forEach((compId, index) => {
    const comp = comps?.[compId];
    comp &&
      reportFields.append(
        ...generateTkv2AdjustmentsRptiNodes(doc, comp, index, FormType.fnma1004c, meta),
      );
  });

  fnma1004AdditionalComps.appendChild(reportFields);

  return fnma1004AdditionalComps;
}
